import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import {InputRow} from '../../components'
import {onChangeInput, validateInputs} from "../../services/utils";
import {useStyles} from "../auth/signIn/authStyles";
import {initialState} from "./constant";
import {userCountryOption} from '../../environment'
import Alert from "../../components/alert";

export default function AddNewHarvest(props) {
  const classes = useStyles();
  const [state, setState] = useState(initialState);

  const {values, errors} = state;
  const [countries, setCountries] = useState([])
  const [stateList, setStateList] = useState([])
  const [cityList, setCityList] = useState([])
  const [sectorList, setSectorList] = useState([])
  const [yieldList, setYieldList] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")
  const checks = [{text: "Yes", value: "y"}, {text: "No", value: "n"}]
  let farming = JSON.parse(localStorage.getItem("farming") || "[]")


  const addService = (e) => {
    e.preventDefault();
    let {

      avgWeightSize,
      moisturePtg,
      moq,
      yieldDetailId
    } = values;
    let data = {

      avgWeightSize,
      moisturePtg,
      moq,
      yieldDetailId
    };

    let recordedErrors = validateInputs(data);

    // if (Object.keys(recordedErrors).length > 0) {
    //      console.log("error", recordedErrors);
    //      setState((prevState) => ({
    //        ...prevState,
    //        errors: recordedErrors,
    //      }));
    //    } else {
    //      let bodyFormData = new FormData();
    //      bodyFormData.append('file', file);
    //      HttpService.post(`product/saveProduct?expectedYield=${expectedYield}&gradingRequested=${gradingRequested}&manPowerRequested=${manPowerRequested}&priceSetByVendor=${priceSetByVendor}&publishImmediately=${publishImmediately}&purchasedDate=${purchasedDate}&purchasedFrom=${purchasedFrom}&qty=${qty}&cityId=${cityId}&qtyName=${qtyName}&subSpeciesName=${subSpeciesName}&userId=${user?.ssoId}&sectorId=${sectorId}&yieldDetailId=${yieldDetailId}&productDesciption=${description}&avgWeightSize=${avgWeightSize}&moisturePtg=${moisturePtg}&moq=${moq}`
    //       ,bodyFormData).then(res => {
    //        if (res) {
    //          if(res?.data?.message == "SUCCESS")
    //          setSuccess(res?.data?.messageText)
    //        setTimeout(() => {
    //          setSuccess("")
    //        }, 2000);
    //      } else
    //        setError(res?.data?.messageText)
    //      setTimeout(() => {
    //        setError("")
    //      }, 2000);
    //    });
    //  }
  };


  return (
    <>
      {((error || success)) &&
      <Alert type={error ? 'error' : 'success'}
             message={error || success}/>
      }

      <Container className={`mb-20   `}>
        <div className={classes.paper} style={{marginTop: 0}}>
          <h1 className='align-self-start text-normal'>Add Harvest</h1>
          <form className={classes.form} >
            <InputRow
              types={[
                {id: 'transactionId', value: values.transactionId, error: errors.transactionId, label: 'transaction Id'},

              ]}
              onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
              numOfInputPerRow={4}
            />
            <InputRow
              types={[
                {
                  type: 'select',
                  value: values.agriSector,
                  error: errors.agriSector,
                  label: 'agri sector',
                  id: 'agriSector',
                  dropdownList: userCountryOption
                },  {
                  type: 'select',
                  value: values.category,
                  error: errors.category,
                  label: 'category',
                  dropdownList: userCountryOption
                }, {
                  type: 'select',
                  value: values.subCategory,
                  error: errors.subCategory,
                  label: 'sub-Category',
                  id: 'subCategory',
                  dropdownList: userCountryOption
                },

              ]}
              onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
              numOfInputPerRow={3}
            />

            <div className='mt-10'>
              <InputRow
                types={[
                  {
                    type: 'select',
                    value: values.city,
                    error: errors.city,
                    label: 'city',
                    dropdownList: userCountryOption
                  },
                   {
                    type: 'select',
                    value: values.state,
                    error: errors.state,
                    label: 'state',
                    dropdownList: userCountryOption
                  },
                   {
                    type: 'select',
                    value: values.country,
                    error: errors.country,
                    label: 'country',
                    dropdownList: userCountryOption
                  },
                   {
                    type: 'select',
                    value: values.currency,
                    error: errors.currency,
                    label: 'currency',
                    dropdownList: userCountryOption
                  },
                   {
                    type: 'select',
                    value: values.orderQty,
                    error: errors.orderQty,
                    id: 'orderQty',
                    label: ' minimum order Qty',
                    dropdownList: userCountryOption
                  },
                   {
                    type: 'select',
                    value: values.nutrientValue,
                    error: errors.nutrientValue,
                    label: 'nutrient Value',
                    id: 'nutrientValue',
                    dropdownList: userCountryOption
                  },
                   {
                    type: 'select',
                    value: values.moistureValue,
                    error: errors.moistureValue,
                    id: 'moistureValue',
                    label: 'moisture Value percentage',
                    dropdownList: userCountryOption
                  },
                   {
                    type: 'select',
                    value: values.weightSize,
                    error: errors.weightSize,
                    label: 'Avg weight Size',
                    id: 'weightSize',
                    dropdownList: userCountryOption
                  },

                   {
                    type: 'select',
                    value: values.measureUnit,
                    error: errors.measureUnit,
                    label: 'measureUnit',
                    dropdownList: userCountryOption
                  },
                   {
                    type: 'select',
                    value: values.purchasedFrom,
                    error: errors.purchasedFrom,
                    label: 'purchasedFrom',
                    dropdownList: userCountryOption
                  },
                   {
                    type: 'date',
                    value: values.purchasedDate,
                    error: errors.purchasedDate,
                    label: 'purchasedDate',
                    // dropdownList: userCountryOption
                  },
                   {
                    type: 'select',
                    value: values.expectedYield,
                    error: errors.expectedYield,
                    label: 'expectedYield',
                    dropdownList: userCountryOption
                  },
                   {
                    type: 'date',
                    value: values.harvestDate,
                    error: errors.harvestDate,
                    label: 'harvestDate',
                    // dropdownList: userCountryOption
                  },
                   {
                    type: 'select',
                    value: values.gradedBy,
                    error: errors.gradedBy,
                    label: 'gradedBy',
                    dropdownList: userCountryOption
                  },
                  {
                    type: 'date',
                    value: values.gradedDate,
                    error: errors.gradedDate,
                    label: 'gradedDate',
                  },
                  {value: values.secondGrader, error: errors.secondGrader, label: 'secondGrader'},
                ]}
                onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                numOfInputPerRow={4}
              />
            </div>
            <div className='mt-10'>
              <InputRow
                types={[
                  {value: values.description, error: errors.description, label: 'description'},

                ]}
                onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                numOfInputPerRow={1}
              />
            </div>
            <div className='mt-10'>
              <InputRow
                types={[
                  {type: 'file', value: values.harvestImage, error: errors.harvestImage, label: 'upload file',id:'harvestImage'},

                ]}
                onChangeInput={(value, key) => onChangeInput(value, key, state, setState)}
                numOfInputPerRow={3}
              />
            </div>

            <Grid container spacing={2} className='mt-20 mb-20 pl-10  pr-10'>
              <Grid item lg={12} xs={12} className={'  display-flex justify-content-end'}>
                {/*<br></br>*/}
                <Button type="submit" variant="contained" color="primary"
                        onClick={(e) => addService(e)}>
                  Add Harvest
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </Container>
    </>
  );
}
